import * as React from 'react';
import { useContext } from 'react';
import { LinkContext } from '../../../util/LinkContext.js';
import { jsx, Fragment } from 'react/jsx-runtime';

const Link = ({
  children,
  href,
  passHref = true
}) => {
  const NextLink = useContext(LinkContext);
  if (NextLink) {
    return /* @__PURE__ */ jsx(NextLink, {
      href,
      passHref,
      legacyBehavior: true,
      children
    });
  }
  return /* @__PURE__ */ jsx(Fragment, {
    children: React.Children.map(children, (child) => /* @__PURE__ */ React.isValidElement(child) && child.type === "a" ? /* @__PURE__ */ jsx("a", {
      ...child.props,
      href,
      children: child.props.children
    }) : child)
  });
};

export { Link as default };
//# sourceMappingURL=Link.js.map
